<script>
export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    firstSocialNetwork() {
      return this.postsBySocialNetwork[0];
    },
    postTypesForFirstSocialNetwork() {
      if (!this.campaignOverview.agreed_posts) {
        return []
      }

      return this.campaignOverview.agreed_posts
          .filter(agreedPost => {
            return agreedPost.social_network === this.firstSocialNetwork.socialNetwork && agreedPost.status !== 'negotiable'
          })
          .map(agreedPost => agreedPost.post_type)
          .reduce((result, item) => {
            if (!result.hasOwnProperty(item)) {
              result[item] = 0
            }
            result[item] += 1;

            return result;
          }, {})
    },
    postsBySocialNetwork() {
      let postsBySocialNetworks = this.campaignOverview.posts_by_social_network ?? {};
      postsBySocialNetworks = {
        ... {
          instagram: 0,
          facebook: 0,
          youtube: 0,
          blog: 0,
        },
        ...postsBySocialNetworks
      }


      return Object.keys(postsBySocialNetworks)
          .map(socialNetwork => {
            return {
              socialNetwork: socialNetwork,
              posts: postsBySocialNetworks[socialNetwork]
            }
          })
          .sort((a, b) => b.posts - a.posts)
    }
  },
}
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h4 class="card-title mb-4">Social Network Breakdown</h4>

      <div >
        <div class="text-center">
          <div class="avatar-sm mx-auto mb-4">
          <span class="avatar-title rounded-circle font-size-24" :class="firstSocialNetwork.socialNetwork + '-background'">
            <i v-if="firstSocialNetwork.socialNetwork === 'instagram'" class="mdi mdi-instagram text-white"></i>
            <i v-else-if="firstSocialNetwork.socialNetwork === 'facebook'" class="mdi mdi-facebook text-white"></i>
            <i v-else-if="firstSocialNetwork.socialNetwork === 'youtube'" class="mdi mdi-youtube text-white"></i>
            <i v-else-if="firstSocialNetwork.socialNetwork === 'blog'" class="fas fa-blog text-white"></i>
          </span>
          </div>
          <p class="font-16 text-muted mb-2"></p>
          <h5>
            <span class="text-dark">
              <span class="text-capitalize">{{ firstSocialNetwork.socialNetwork }}</span>
              <span class="text-muted font-16"> - {{ firstSocialNetwork.posts }} posts</span>
            </span>
          </h5>
          <p class="text-muted">
          <span v-for="(postType, index) in Object.keys(postTypesForFirstSocialNetwork)" :key="postType">
            {{ postTypesForFirstSocialNetwork[postType] }} {{ postType.plural() | snakeToWords }}<span
              v-if="index !== Object.keys(postTypesForFirstSocialNetwork).length-1">,</span>
          </span>
          </p>
        </div>


        <div class="row mt-4">

          <div class="col-sm-4" v-for="postsCount in postsBySocialNetwork.slice(1, 4)" :key="postsCount.socialNetwork">
            <div class="social-source text-center mt-3">
              <div class="avatar-xs mx-auto mb-3">
                <span class="avatar-title rounded-circle font-size-16" :class="postsCount.socialNetwork + '-background'">
                  <i v-if="postsCount.socialNetwork === 'instagram'" class="mdi mdi-instagram text-white"></i>
                  <i v-else-if="postsCount.socialNetwork === 'facebook'" class="mdi mdi-facebook text-white"></i>
                  <i v-else-if="postsCount.socialNetwork === 'youtube'" class="mdi mdi-youtube text-white"></i>
                  <i v-else-if="postsCount.socialNetwork === 'blog'" class="fas fa-blog text-white"></i>
                </span>
              </div>
              <h5 class="font-size-15 text-capitalize">{{ postsCount.socialNetwork }}</h5>
              <p class="text-muted mb-0">{{ postsCount.posts }} posts</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
